import React from "react";
import Layout from "../../components/layout";

const Viewpaidinvoices = () => {
  return <>Viewpaidinvoices</>;
};

export default Viewpaidinvoices;
